import React from "react";
import PropTypes from "prop-types";
import { StaticQuery, graphql } from "gatsby";

import Header from "./header";

const Layout = ({children}) => (
  <StaticQuery
    query = { graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `}
    render = { data => (
      <div className="h-full w-full">
      <Header />
      <div className="flex flex-col h-full w-full content">
        <main className="flex-auto">
          {children}
        </main>
        <footer className="flex-20px">
          © {new Date().getFullYear()}, Built with
          {` `}
          <a href="https://www.gatsbyjs.com">Gatsby</a>
        </footer>
      </div>
    </div>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout;
